const shared = {
  caliberTitle: 'Caliber version and data cutoff',
  caliber: 'Caliber',
  through: 'Through',
  batch: 'Batch',
  denominator: 'Denominator',
  loading: 'Reading measurement data…',
  readFailure: 'This data could not be loaded',
  readFailureClarification: 'This does not mean the company was absent in AI results. The read failed; those are different facts.',
  permissionTitle: 'You do not have access to this project',
  permissionBody: 'Switch to an authorized project or ask the project owner to grant access.',
  retry: 'Try again',
  closeEvidence: 'Close evidence',
  provenance: {
    real: 'Real data',
    construct: 'Construct',
    placeholder: 'Placeholder',
  },
  session: {
    secureSession: 'Navigator access',
    contextTitle: 'Enter Navigator.',
    contextBody: 'Continue securely to your workspace.',
    pathLabel: 'Account setup progress',
    pathOneTitle: 'Verify email',
    pathOneBody: 'A one-time sign-in link is sent only to an active workspace member.',
    pathTwoTitle: 'Choose or create a company',
    pathTwoBody: 'Your session can read only the projects assigned to that company.',
    pathThreeTitle: 'Start working',
    pathThreeBody: 'Diagnosis, actions and results reopen without exposing an internal credential.',
    memberEntry: 'Get started',
    requestTitle: 'Continue with email.',
    requestLead: 'Existing members sign in. New users create a workspace after verification.',
    afterLogin: 'After sign-in',
    destination: {
      diagnosis: 'Return to diagnosis',
      results: 'Return to results',
      action: 'Return to actions',
      research: 'Return to enterprise research',
    },
    emailLabel: 'Work email',
    invalidEmail: 'Enter a valid work email address.',
    sendLink: 'Continue',
    sending: 'Sending…',
    privacyTitle: 'Member-only access.',
    privacyBody: 'Used only for sign-in and essential account notices.',
    checkEyebrow: 'Request accepted',
    checkTitle: 'Check your inbox',
    checkLead: 'We sent a secure link. Open it on this device to continue.',
    linkLifetime: 'Link valid for 15 minutes',
    resendShort: 'Send again',
    changeEmail: 'Use another email',
    verifyingEyebrow: 'Verifying membership',
    verifyingTitle: 'Opening your workspace',
    verifyingLead: 'The one-time link is being exchanged for a protected browser session.',
    expiredEyebrow: 'Link unavailable',
    expiredTitle: 'This sign-in link has expired or was already used',
    expiredLead: 'Request a new link with the same authorized work email. Your project data has not changed.',
    requestNewLink: 'Request a new link',
    problemEyebrow: 'Connection interrupted',
    problemTitle: 'We could not request a sign-in link',
    problemLead: 'Check your connection and try again. No workspace data was changed.',
    chooseSpaceEyebrow: 'Enterprise spaces',
    chooseSpaceTitle: 'Choose an enterprise space',
    chooseSpaceLead: '{email} can access more than one enterprise space. Only the selected space will be loaded, and you can switch again later.',
    openingSpace: 'Opening…',
    chooseSpaceFailed: 'This enterprise space could not be opened. Please try again.',
    createEyebrow: 'Email verified',
    createContextTitle: 'One identity. Every company you belong to.',
    createContextBody: 'Create the company space that will hold your projects, members, memory, and entitlements.',
    createTitle: 'Create a workspace.',
    createLead: 'Add the basics. Solo founders can use a brand or studio name.',
    verifiedIdentity: 'Verified',
    orgName: 'Company / brand / team name',
    region: 'Primary operating region',
    website: 'Website or profile',
    optional: 'Optional',
    terms: 'I may represent this company and agree to the Terms and Privacy Policy.',
    createButton: 'Create workspace',
    creatingWorkspace: 'Creating…',
    regionCN: 'Mainland China',
    regionGlobal: 'Other country or region',
    regionHK: 'Hong Kong, China',
    regionTW: 'Taiwan, China',
    regionJP: 'Japan',
    regionKR: 'South Korea',
    createBoundary: 'Registration does not start a paid plan.',
    companyNameInvalid: 'Enter a company, brand, or team name.',
    termsRequired: 'Accept the terms before continuing.',
    registrationFailed: 'The workspace could not be created. Please try again.',
    footerSecurity: 'One-time link · protected cookie · tenant isolation',
    footerHelp: 'Need help · hello@monolithos.ai',
  },
} as const

export default shared
